var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.panelLoading,
          expression: "panelLoading",
        },
      ],
      staticClass: "main-class",
    },
    [
      _c(
        "de-aside-container",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.viewLoading,
              expression: "viewLoading",
            },
          ],
          staticClass: "aside-class",
          attrs: { type: "panel" },
        },
        [
          _c("multiplexing-view", {
            attrs: { "view-data": _vm.viewData },
            on: { showDetails: _vm.showDetails },
          }),
        ],
        1
      ),
      _c(
        "de-main-container",
        [
          _vm.selectedPanel
            ? _c("Preview", {
                attrs: {
                  "component-data": _vm.mainCanvasComponentData,
                  "canvas-style-data": _vm.canvasStyleData,
                  "panel-info": _vm.panelInfo,
                  "show-position": _vm.showPosition,
                },
              })
            : _c(
                "el-col",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "custom-position",
                      staticStyle: {
                        height: "100%",
                        "background-color": "var(--ContentBG)",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("panel.select_panel_from_left")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }